import { Typography, Accordion, AccordionSummary, AccordionDetails, Stack, Dialog, DialogContent, DialogTitle, DialogActions, Button, TextField } from '@mui/material';
import React, { useState } from 'react';
import dayjs from 'dayjs';
import KoriDetails from '@/components/KoriList/KoriDetails';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { updateKoriNimi } from '@/services/koriService';

const KoriListItem = ({ item }) => {
  // Muutetaan data helpommin käsiteltävään muotoon
  const data = {
    id: item.id.id,
    nimi: item.nimi,
    alkuaika: item.alkuaika,
    loppuaika: item.loppuaika,
    vahvistuspvm: item.vahvistuspvm,
    muokattu: item.muokattu,
    asiakasInfo: item.asiakasInfo,
    muokkaaja: item.muokkaaja,
    info: item.info,
    korinSumma: item.korinSumma,
    asiakasEtunimi: item.asiakasEtunimi,
    asiakasSukunimi: item.asiakasSukunimi,
    asiakasYritysnimi: item.asiakasYritysnimi,
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [nimi, setNimi] = useState(data.nimi || '');
  const [updatedNimi, setUpdatedNimi] = useState(nimi);
  const { t } = useTranslation();

  const handleDialogOpen = (e) => {
    e.stopPropagation();
    setUpdatedNimi(nimi);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleSave = async () => {
    try {
      await updateKoriNimi({ id: data.id, nimi, updatedNimi });
      toast.success(t('koriListItem.nameUpdated'));
      setNimi(updatedNimi);
    }
    catch (error) {
      toast.error(t('koriListItem.nameUpdatedError') + error.message);
    }

    setDialogOpen(false);
  };

  // TODO: dialogi pitää ehkä vaihtaa formiksi?
  return (
    <>
      <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
        <AccordionSummary>
          <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
            <ShoppingCartOutlinedIcon />
            <Stack direction="column" spacing={0}>
              <Typography color="darkGreen"><strong>{nimi ? nimi : t('koriListItem.noName')}</strong></Typography>
              <Typography>{data.alkuaika ? dayjs(data.alkuaika).format('DD.MM.YYYY HH:mm') : t('koriListItem.noReservation')}</Typography>
              <Typography>{data.asiakasYritysnimi ? data.asiakasYritysnimi : (data.asiakasEtunimi && data.asiakasSukunimi ? data.asiakasSukunimi + ' ' + data.asiakasEtunimi : t('koriListItem.noCustomer'))}</Typography>
            </Stack>
            <Stack alignItems="flex-end" spacing={0} sx={{ flexGrow: 1 }}>
              <Typography variant="caption" sx={{ textAlign: 'right', width: '100%' }}>
                {data.vahvistuspvm ? `${t('koriListItem.confirmed')} ${dayjs(data.vahvistuspvm).format('DD.MM.YYYY')}` : t('koriListItem.notConfirmed')}
              </Typography>
              <Typography variant="caption" sx={{ textAlign: 'right', width: '100%' }}>
                {data.korinSumma ? `${t('koriListItem.totalPrice')} ${data.korinSumma} €` : t('koriListItem.noPrice')}
              </Typography>
              <Typography variant="caption" sx={{ textAlign: 'right', width: '100%' }}>
                {data.id ? `${t('koriListItem.reservation')} ${data.id}` : ''}
              </Typography>
            </Stack>
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={{ px: 0 }}>
          {data.id != null && <KoriDetails id={data.id} onEditNimi={handleDialogOpen} />}
        </AccordionDetails>
      </Accordion>

      <Dialog open={dialogOpen} onClose={handleDialogClose} fullWidth keepMounted={false}>
        <DialogTitle>{t('koriListItem.editName')}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label={t('koriListItem.basketName')}
            type="text"
            fullWidth
            variant="outlined"
            value={updatedNimi}
            onChange={e => setUpdatedNimi(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>{t('koriListItem.cancel')}</Button>
          <Button onClick={handleSave}>{t('koriListItem.save')}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default KoriListItem;
